"use client";
import { Snackbar } from "@mui/material";
import { AtAlertProps, AtAlertVariant } from "./at-alert.types";
import { AtIcon, IconName } from "../at-icon";
import { AtButton, AtButtonSize, AtButtonType } from "../at-button";

export const AtAlert = ({
  open,
  alertText,
  timeOut,
  setClose,
  className,
  variant,
  action,
  buttonText,
  buttonClassName,
  showCloseButton = false,
  autoClose = true,
  backdropClose = true,
  "data-testid": testId,
}: AtAlertProps) => {
  const getAlertProps = (): { iconName: IconName; mainColor: string } => {
    switch (variant) {
      case AtAlertVariant.SUCCESS:
        return {
          iconName: "check-circle",
          mainColor: "var(--color-success-500)",
        };
      case AtAlertVariant.ERROR:
        return {
          iconName: "error",
          mainColor: "var(--color-error-600)",
        };
      case AtAlertVariant.WARNING:
        return {
          iconName: "warning",
          mainColor: "var(--color-warning-500)",
        };
      case AtAlertVariant.INFO:
        return {
          iconName: "error",
          mainColor: "var(--color-info-500)",
        };
    }
  };

  const { iconName, mainColor } = getAlertProps();

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoClose ? timeOut : null}
      onClose={backdropClose ? setClose : undefined}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      className={className}
      data-testid={testId}
    >
      <div
        className="bg-white w-[507px] text-left rounded-sm p-[20px] max-h-[78px] shadow-mid-center border-l-[6px]"
        style={{ borderLeftColor: mainColor }}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[20px] ">
            <div
              className={`w-[26px] h-[26px] rounded-full`}
              style={{ color: mainColor }}
            >
              <AtIcon name={iconName} size={26.67} />
            </div>
            <div className="text-normal font-normal"> {alertText}</div>
          </div>

          <div className="flex items-center gap-[20px]">
            {action && buttonText && (
              <AtButton
                className={buttonClassName}
                style={{
                  backgroundColor: `${mainColor}!important`,
                  padding: "4px 32px",
                  whiteSpace: "nowrap",
                }}
                text={buttonText || ""}
                onClick={action}
                buttonType={AtButtonType.PRIMARY}
                size={
                  buttonClassName ? AtButtonSize.CUSTOM : AtButtonSize.MEDIUM
                }
              />
            )}
            {showCloseButton && (
              <button
                onClick={setClose}
                className="text-surface-300 cursor-pointer"
              >
                <AtIcon name="close" size={24} />
              </button>
            )}
          </div>
        </div>
      </div>
    </Snackbar>
  );
};
